import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import { type Table } from '@tanstack/vue-table';
    import { Plus, Minus } from 'lucide-vue-next';

    import { Button } from '@/components/ui/button';

    interface DataTablePaginationProps {
        table: Table<any>;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableGroupToggle',
  props: {
    table: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_ctx.table.getCanSomeRowsExpand())
    ? (_openBlock(), _createBlock(_unref(Button), {
        key: 0,
        variant: "ghost",
        width: "narrow",
        class: _normalizeClass(["self-start", _ctx.table.getIsAllRowsExpanded() ? 'hover:text-destructive' : 'hover:text-accent']),
        size: "xs",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.table.toggleAllRowsExpanded(!_ctx.table.getIsAllRowsExpanded())))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.table.getIsAllRowsExpanded()
                ? _ctx.$t('datatables.collapse_all')
                : _ctx.$t('datatables.expand_all')) + " ", 1),
          (_ctx.table.getIsAllRowsExpanded())
            ? (_openBlock(), _createBlock(_unref(Minus), {
                key: 0,
                class: "text-destructive"
              }))
            : (_openBlock(), _createBlock(_unref(Plus), {
                key: 1,
                class: "text-accent"
              }))
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}
}

})